import { adminApi, storeApi } from "@/services/ApiService";

// Store images never change, so they can be kept for the session
const storeThumbnails = new Map<number, Promise<string>>();
const storeImages = new Map<number, Promise<string>>();

function cached(
  cache: Map<number, Promise<string>>,
  imageId: number,
  load: () => Promise<string>
): Promise<string> {
  let result = cache.get(imageId);
  if (result) return result;
  result = load();
  result.catch(() => cache.delete(imageId));
  cache.set(imageId, result);
  return result;
}

export function getStoreThumbnail(imageId: number): Promise<string> {
  return cached(storeThumbnails, imageId, () =>
    storeApi.getThumbnail(imageId).then((c) => "data:image/png;base64," + c.data)
  );
}

export function getStoreImage(imageId: number): Promise<string> {
  return cached(storeImages, imageId, () =>
    storeApi.getImage(imageId).then((c) => "data:image/png;base64," + c.data)
  );
}

export async function getValidatedThumbnail(plu: string): Promise<string> {
  let result = await adminApi.getValidatedProductThumbnail(plu);
  return "data:image/png;base64," + result.data;
}

export async function getValidatedImage(plu: string): Promise<string> {
  let result = await adminApi.getValidatedProductImage(plu);
  return "data:image/png;base64," + result.data;
}
